import {
  AuthenticatedUserDTO,
  LoginResponseDTO,
} from '../domain/authentication.dto'
import apiClient from '../infraestructure/apiClient'

export const getAuthenticatedUserPath = `/security/getAuthenticatedUser`
export const loginPath = `/security/login`

export default {
  getAuthenticatedUser: function() {
    return apiClient.get<AuthenticatedUserDTO>(getAuthenticatedUserPath)
  },
  login: async function(user: string, clearPassword: string) {
    return await apiClient.post<LoginResponseDTO>(loginPath, {
      user,
      clearPassword,
    })
  },
}
